<template>
  <div class="cloud-document-page">
    <special-head title="资料沉淀">
      <template #extra>
        <div class="update-document" v-if="permission == 1 && isfold">
          <jw-button type="text" size="small" class="update-btn" v-if="hasAddDocumentPermission" @click.stop="uploadCloud"><qfei-icon-add-two-outlined />{{ $t('新建') }}</jw-button>
          <jw-button type="text" size="small" class="update-btn" v-if="hasUploadAttachmentPermission" @click.stop="uploadAttachment"><qfei-icon-attachment-outlined />{{ $t('上传附件') }}</jw-button>
        </div>
      </template>
    </special-head>
    <special-table v-if="isfold" :checkedParams="{ width: 38 }" :columns="columns" :data="dataList" :pagination="pagination" @paginationEvent="onPaginationEvent" :loading="loading">
      <template #documentType="{ row }">
        <span>{{ row.documentTypeName }}</span>
      </template>
      <template #documentName="{ row }">
        <template v-if="row?.documentUrl">
          <jw-link style="word-break: break-all" :href="row?.documentUrl" target="_blank">{{ row.documentName }}</jw-link>
        </template>
        <template v-else>-</template>
      </template>
      <!-- 来源模块 -->
      <template #type="{ row }">
        {{ getSourceType(row.type) }}
      </template>
      <template #operation="{ row }">
        <template v-if="permission == 1">
          <jw-link v-if="row.fileType == 1 && hasCopyDocumentPermission" @click="copyText(row)">{{ $t('复制') }}</jw-link>
          <jw-link v-if="row.fileType == 2 && hasDownloadAttachmentPermission" :href="row.documentUrl" :download="row.documentUrl" target="_blank">
            {{ $t('下载') }}
          </jw-link>
          <jw-link v-if="hasDeleteAttachmentPermission(row)" @click="deleteHandle(row)">{{ $t('删除') }}</jw-link>
        </template>
      </template>
    </special-table>
    <div class="card-cloud-transform-content" v-if="isfold">
      <!-- 上传云文档 -->
      <upload-cloud-document ref="uploadCloudRefs" @cb="getCloudDocument"></upload-cloud-document>
      <!-- 上传附件 -->
      <upload-attachment ref="uploadAttachmentRefs" @cb="getCloudDocument"></upload-attachment>
      <!-- 删除提示 -->
      <template>
        <jw-modal v-model:visible="modalVisible" @ok="handleOk" @cancel="handleCancel" title-align="start">
          <template #title> {{ $t('温馨提示') }} </template>
          <div>{{ $t('tips.voidDeleteAnnex') }}</div>
        </jw-modal>
      </template>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, inject, ref, onMounted } from 'vue';
import useLoading from '@/hooks/loading';
import { opportunityService, layoutService } from '@/api/';
import uploadCloudDocument from './upload-cloud-document/upload-cloud-document.vue';
import uploadAttachment from './upload-attachment/upload-attachment.vue';
import { Message } from '@arco-design/web-vue';
import { useUserStore } from '@/store';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
import SpecialTable from '@/components/fh-detail/components/special-table/index.vue';
import { useI18n } from 'vue-i18n';
import useFhSpecialTable from '@/hooks/fh-special-table';

export default {
  components: {
    uploadCloudDocument,
    uploadAttachment,
    SpecialHead,
    SpecialTable
  },
  props: {
    moduleId: {
      type: String,
      default: ''
    }
  },
  setup(props, ctx) {
    const { t } = useI18n();
    const { loading, setLoading } = useLoading(false);
    const uploadCloudRefs = ref(); //上传云文档
    const uploadAttachmentRefs = ref(); //上传附件
    const userStore = useUserStore();
    const data = reactive({
      isfold: true,
      id: inject('detailParams').id,
      type: inject('detailParams').entity,
      permission: inject('detailParams')?.permission, //权限
      fsContractId: inject('detailParams')?.fsContractId, //飞书合同id
      copyValue: '',
      paginationObj: {
        current: 1,
        pageSize: 5,
        total: 0,
        foldedMaxPageBtn: 2,
        maxPageBtn: 4,
        showPageSize: true, // 是否显示数据条数选择器
        showJumper: true,
        size: 'small',
        pageSizeOptions: [5, 10],
        showTotal: true // 是否显示数据总数
      },
      list: [],
      modalVisible: false,
      record: [],
      columns: [
        {
          title: t('文件类型'), //1-客户档案表 2-需求调研表 3-项目整体计划 4-CSP 5-版本对比
          colKey: 'documentType',
          slotName: 'documentType',
          width: 120,
          ellipsis: true,
          tooltip: true
        },
        {
          title: t('文件名称'),
          colKey: 'documentName',
          slotName: 'documentName',
          width: 200,
          ellipsis: true,
          tooltip: true
        },
        {
          title: t('来源模块'),
          colKey: 'type',
          slotName: 'type',
          width: 100
        },
        {
          title: t('创建人'),
          colKey: 'createUserName',
          width: 100
        },
        {
          title: t('创建时间'),
          colKey: 'gmtCreated',
          width: 180,
          ellipsis: true,
          tooltip: true
        },
        {
          title: t('操作'),
          colKey: 'operation',
          slotName: 'operation',
          width: 150,
          fixed: 'right'
        }
      ]
    });

    // 来源模块
    const getSourceType = (type) => {
      let sourceType = '-';
      switch (type) {
        case 1:
          sourceType = t('线索');
          break;
        case 2:
          sourceType = t('客户');
          break;
        case 3:
          sourceType = t('商机');
          break;
        case 4:
          sourceType = t('产品');
          break;
        case 6:
          sourceType = t('报价单');
          break;
        case 8:
          sourceType = t('销售合同');
          break;
        case 10:
          sourceType = t('销售订单');
          break;
        case 12:
          sourceType = t('售后服务');
          break;
        default:
          sourceType = '-';
      }
      return sourceType;
    };

    const requestParas = {
      businessId: data.id,
      type: data.type
    };

    const { pagination, onPaginationEvent, getDataList: getCloudDocument, dataList } = useFhSpecialTable(requestParas, opportunityService.getCloudDocument.bind(opportunityService));

    // 切换
    // const switchfold = () => {
    //   data.isfold = !data.isfold;
    // };

    //复制
    const copyText = (record) => {
      var input = document.createElement('input');
      input.value = record.documentName;
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length);
      document.execCommand('Copy');
      document.body.removeChild(input);
      Message.success(t('复制成功'));
    };
    const sort = (arr) => {
      const map = {};

      arr.forEach((item) => {
        if (map[item.documentType]) {
          map[item.documentType].push(item);
        } else {
          map[item.documentType] = [item];
        }
      });

      return Object.values(map).flat();
    };
    //删除
    const deleteHandle = (record) => {
      data.modalVisible = true;
      data.record = record;
    };
    const handleOk = () => {
      deleteDoc();
    };
    const handleCancel = () => {
      data.record = [];
      data.modalVisible = false;
    };
    const deleteDoc = async () => {
      setLoading(true);
      try {
        const json = await opportunityService.deleteDocument({ id: data.record.id });
        setLoading(false);
        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
          return false;
        }
        Message.success(t('删除成功'));
        getCloudDocument();
        ctx.emit('cb');
      } catch (e) {
        console.log(e);
      }
    };
    //查看云文档
    const cloudDetails = () => {};
    // 通用权限检查函数
    const checkPermission = (permissionMap) => {
      const currentPerm = permissionMap[data.type];
      if (!currentPerm) return false;

      const hasRole = userStore.userInfo?.roles?.indexOf(currentPerm.role) !== -1;
      const hasButton = buttons.value.indexOf(currentPerm.role) > -1;
      const meetsSpecialCondition = currentPerm.specialCondition === null || currentPerm.specialCondition;

      return hasRole && hasButton && meetsSpecialCondition;
    };
    const getPermissionMap = (key) => {
      const permissionMap = {
        3: { role: `businessOpportunity:${key}`, specialCondition: null },
        2: { role: `customer:${key}`, specialCondition: null },
        8: { role: `contract:${key}`, specialCondition: !data.fsContractId },
        10: { role: `saleOrder:${key}`, specialCondition: null },
        12: { role: `afterSale:${key}`, specialCondition: null }
      };
      return permissionMap;
    };
    //检查是否有新增云文档权限
    const hasAddDocumentPermission = () => {
      return checkPermission(getPermissionMap('addDocument'));
    };

    //检查是否有上传附件权限
    const hasUploadAttachmentPermission = () => {
      return checkPermission(getPermissionMap('uploadAttachments'));
    };

    //检查是否有复制文档权限
    const hasCopyDocumentPermission = () => {
      return checkPermission(getPermissionMap('copyDocument'));
    };

    //检查是否有下载附件权限
    const hasDownloadAttachmentPermission = () => {
      return checkPermission(getPermissionMap('downAttachments'));
    };

    //检查是否有删除附件权限
    const hasDeleteAttachmentPermission = (row) => {
      // 检查文档类型条件：不是销售合同类型 或 是销售合同但文档类型不是19
      const documentTypeCondition = data.type != 8 || (data.type == 8 && row.documentType != 19);
      if (!documentTypeCondition) return false;
      return checkPermission(getPermissionMap('delAttachments'));
    };

    //上传云文档
    const uploadCloud = () => {
      uploadCloudRefs.value.open();
    };
    // 上传附件
    const uploadAttachment = () => {
      uploadAttachmentRefs.value.open();
    };
    onMounted(() => {
      getCloudDocument();
      if (data.type != 2) {
        data.columns.splice(3, 1);
      }
      getDetail();
    });
    const buttons = ref([]);
    const getDetail = async () => {
      if (!props?.moduleId) {
        return false;
      }
      try {
        const params = {
          entity: data.type,
          moduleId: props.moduleId,
          businessId: data.id,
          apiIndex: props.moduleId
        };
        const json = await layoutService.getDetail(params);
        if (!json.error) {
          const _buttons = [];
          json?.result?.map((b) => {
            _buttons.push(b.value);
          });
          buttons.value = _buttons;
        }
      } catch (e) {
        console.log(e);
      }
    };
    return {
      dataList,
      pagination,
      onPaginationEvent,
      loading,
      uploadCloudRefs,
      uploadAttachmentRefs,
      userStore,
      buttons,
      sort,
      handleOk,
      handleCancel,
      copyText,
      deleteHandle,
      deleteDoc,
      cloudDetails,
      uploadCloud,
      uploadAttachment,
      getCloudDocument,
      getSourceType,
      getPermissionMap,
      hasUploadAttachmentPermission,
      hasAddDocumentPermission,
      hasDownloadAttachmentPermission,
      hasCopyDocumentPermission,
      hasDeleteAttachmentPermission,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-cloud-document.less';
</style>
